import {Directive, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {SubscriptionsService} from '../../services/subscriptions/subscriptions.service';
import {ActivatedRoute} from '@angular/router';

@Directive({
  selector: '[appBusinessLimitation]'
})
export class BusinessLimitationDirective implements OnInit {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private subscriptionsService: SubscriptionsService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    const profileId = this.route.snapshot.params.profile;

    if (this.subscriptionsService.getBusinessPremiumSubscriptionExistance(profileId)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
